"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getThemeColoring = exports.getColor = exports.getColoringType = exports.darken = exports.lighten = exports.opaque = exports.isLight = exports.generateColorFromString = exports.getLegibleTextColor = void 0;
var color_1 = __importDefault(require("color"));
var color_hash_1 = __importDefault(require("color-hash"));
var find_1 = __importDefault(require("lodash/find"));
var get_1 = __importDefault(require("lodash/get"));
var memoize_1 = __importDefault(require("lodash/memoize"));
var colorHash = new color_hash_1.default();
var shadeCustomColor = function (color, shade) {
    if (shade === 'main') {
        return color;
    }
    if (shade === 'light') {
        return exports.lighten(color);
    }
    return exports.darken(color);
};
exports.getLegibleTextColor = memoize_1.default(function (bg, contrast) {
    if (contrast === void 0) { contrast = 4.5; }
    var bgColor = new color_1.default(bg);
    var findWithContrast = function (darken) {
        if (darken >= 1) {
            return bgColor.darken(1).hex();
        }
        var textColor = bgColor.darken(darken);
        if (textColor.contrast(bgColor) >= contrast) {
            return textColor.hex();
        }
        return findWithContrast(darken + 0.05);
    };
    return findWithContrast(0.1);
});
exports.generateColorFromString = memoize_1.default(function (text) {
    return colorHash.hex(text.replace(/\s/g, ''));
});
exports.isLight = function (color) {
    return color_1.default(color).luminosity() > 0.65;
};
exports.opaque = function (color, opacity) {
    return new color_1.default(__spreadArrays(color_1.default(color).array(), [opacity])).string();
};
exports.lighten = function (color) { return color_1.default(color).fade(0.3).string(); };
exports.darken = function (color, amount) {
    return color_1.default(color)
        .darken(amount || 0.2)
        .string();
};
exports.getColoringType = function (props) {
    var type = find_1.default(Object.keys(props), function (b) {
        return !!props[b] && !!find_1.default(Object.keys(props.theme.colors), function (k) { return k === b; });
    });
    return type;
};
exports.getColor = function (props, key, shade) {
    if (get_1.default(props, key)) {
        return shadeCustomColor(get_1.default(props, key), shade);
    }
    var type = exports.getColoringType(props);
    if (type) {
        var color = get_1.default(props.theme, "colors." + type);
        if (color != null && typeof color === 'object') {
            return color[shade];
        }
        else {
            return shadeCustomColor(color, shade);
        }
    }
};
exports.getThemeColoring = function (theme, props, shade) {
    if (shade === void 0) { shade = 'main'; }
    var type = find_1.default(Object.keys(props), function (b) { return !!props[b] && !!theme.colors[b]; });
    if (type) {
        return exports.getColor(__assign(__assign({}, props), { theme: theme }), type, shade);
    }
    return '';
};
